import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import './ListDownloadLink.scss';
import * as XLSX from 'xlsx';
export const ListDownloadLink = ({ className = '', disabled = false, callToAction = 'Krever abonnement', defaultKnr = '', knrName = 'Knr', labelName = 'Kommune', valueName = 'Rangering', sheetName = 'Ark1', baseName = 'rangering', linkText = 'Last ned som Excel-ark', linkTitle = 'Klikk for å laste ned denne listen som en Excel fil', trimAfterComma = true, labelCapture, valueCapture, valueCellFmt = '#,##0', listElement }) => {
    const getCellAddress = (rowIndex, colIndex) => {
        return XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
    };
    const parseNumericValue = (value) => {
        const normalizedValue = value
            .replace(/\u00a0/g, ' ')
            .replace(/\s+/g, '')
            .replace(/,/g, '.')
            .replace(/[^\d.-]/g, '');
        const parsed = Number(normalizedValue);
        return Number.isFinite(parsed) ? parsed : 0;
    };
    const onListDownload = (e) => {
        var _a, _b, _c;
        e.preventDefault();
        if (listElement.current) {
            const rows = Array.from(listElement.current.querySelectorAll('li'))
                .map((listItem) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                const fullLabelText = (_c = (_b = (_a = listItem.querySelector('.label')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : '';
                const labelTexts = fullLabelText.match(/^(\d{4})\s+(.+)$/);
                const knr = (_d = labelTexts === null || labelTexts === void 0 ? void 0 : labelTexts[1]) !== null && _d !== void 0 ? _d : defaultKnr;
                const labelWithOptionalKnr = (_f = (_e = labelTexts === null || labelTexts === void 0 ? void 0 : labelTexts[2]) !== null && _e !== void 0 ? _e : labelTexts === null || labelTexts === void 0 ? void 0 : labelTexts[0]) !== null && _f !== void 0 ? _f : fullLabelText;
                let value;
                const valueText = (_j = (_h = (_g = listItem.querySelector('.value')) === null || _g === void 0 ? void 0 : _g.textContent) === null || _h === void 0 ? void 0 : _h.trim()) !== null && _j !== void 0 ? _j : '';
                if (valueCapture) {
                    value = (_l = (_k = valueText.match(valueCapture)) === null || _k === void 0 ? void 0 : _k[1]) !== null && _l !== void 0 ? _l : valueText;
                }
                else {
                    value = parseNumericValue(valueText);
                }
                if (valueCapture) {
                    value = (_o = (_m = valueText.match(valueCapture)) === null || _m === void 0 ? void 0 : _m[1]) !== null && _o !== void 0 ? _o : valueText;
                }
                let label = trimAfterComma
                    ? labelWithOptionalKnr.split(',')[0].trim()
                    : labelWithOptionalKnr;
                if (labelCapture) {
                    label = (_q = (_p = label.match(labelCapture)) === null || _p === void 0 ? void 0 : _p[1]) !== null && _q !== void 0 ? _q : label;
                }
                return [knr, label, value];
            })
                .filter(([, label]) => !!label);
            if (rows.length === 0) {
                return;
            }
            const worksheetRows = [
                [knrName, labelName, valueName],
                ...rows
            ];
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetRows);
            worksheet['!cols'] = [
                { wch: 7 },
                { wch: 30 },
                { wch: 9 }
            ];
            const headerColumnCount = 3;
            for (let colIndex = 0; colIndex < headerColumnCount; colIndex += 1) {
                const headerCellAddress = getCellAddress(0, colIndex);
                const headerCell = worksheet[headerCellAddress];
                if (headerCell) {
                    headerCell.s = Object.assign(Object.assign({}, ((_a = headerCell.s) !== null && _a !== void 0 ? _a : {})), { font: Object.assign(Object.assign({}, ((_c = (_b = headerCell.s) === null || _b === void 0 ? void 0 : _b.font) !== null && _c !== void 0 ? _c : {})), { bold: true }) });
                }
            }
            const valueColumnIndex = 2;
            for (let rowIndex = 1; rowIndex < worksheetRows.length; rowIndex += 1) {
                const valueCellAddress = getCellAddress(rowIndex, valueColumnIndex);
                const valueCell = worksheet[valueCellAddress];
                if (valueCell) {
                    valueCell.v = Number(valueCell.v);
                    valueCell.t = 'n';
                    valueCell.z = valueCellFmt;
                }
            }
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const downloadUrl = URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = downloadUrl;
            const date = new Date().toISOString().slice(0, 10);
            downloadLink.download = `${baseName}_${date}.xlsx`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
            URL.revokeObjectURL(downloadUrl);
        }
    };
    const title = disabled
        ? callToAction
        : linkTitle;
    const clsx = [
        'list-download-links',
        disabled ? 'disabled' : '',
        className
    ].join(' ');
    return listElement.current ? _jsx("nav", { className: clsx, children: _jsx("a", { title: title, onClick: disabled ? () => { } : onListDownload, children: linkText }) })
        : _jsx(_Fragment, {});
};
